import React from "react";
import { Box, Button as MaterialButton, useMediaQuery } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { Grid } from "ui/grid/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import theme from "theme";
import { useStateMachine } from "../../../StateMachineProvider/StateMachineProvider";
import { RE_ASSURANCE } from "../../../HomeRepairFunnelV2/state-machine/configuration";
import { RepairFunnelFooterMobile } from "./RepairFunnelFooterMobile";
import Button from "../../../design-system/atoms/Button";

interface RepairFunnelFooterProps {
  gotoPreviousStep: () => void;
  gotoNextStep?: () => void;
  shouldDisableContinueButton?: boolean;
  shouldHideNext?: boolean;
}

const buttonTopMargin = 7;

const StaticFooter = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    zIndex: 3,
    position: "fixed",
    margin: 0,
    bottom: 0,
    left: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    borderTop: "1px solid #D7D7D7",
  },
  "@media(max-width: 370px)": {
    padding: `${theme.spacing(1)}px 4px ${theme.spacing(1)}px 0px`,
  },
}));

export const ResponsiveText = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    fontSize: "14px",
  },
}));

export const ResponsiveTotal = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    fontSize: "14px",
  },
}));

const ContinueButton = ({ state, isMobile, shouldDisableContinueButton, gotoNextStep }) => {
  if (!isMobile) {
    let buttonText = "Continuer";
    if (state && state.matches(RE_ASSURANCE)) {
      buttonText = "Voir les disponibilités";
    } else if (state && state.value?.malfunction === "extra_information") {
      buttonText = "Découvrir mon forfait";
    }

    return (
      <Box mt={buttonTopMargin}>
        <Grid item>
          <Button disabled={shouldDisableContinueButton} version="fancy" onClick={gotoNextStep}>
            {buttonText}
          </Button>
        </Grid>
      </Box>
    );
  }
};

export const RepairFunnelFooter: React.FC<RepairFunnelFooterProps> = ({
  gotoPreviousStep,
  gotoNextStep,
  shouldDisableContinueButton,
  shouldHideNext = false,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { state } = useStateMachine();

  return (
    <StaticFooter container item justify="space-between">
      {isMobile ? (
        <RepairFunnelFooterMobile
          state={state}
          shouldDisableContinueButton={shouldDisableContinueButton}
          gotoNextStep={gotoNextStep}
          shouldHideNext={shouldHideNext}
        />
      ) : (
        <>
          <Grid item>
            <Box mt={buttonTopMargin}>
              <MaterialButton startIcon={<ArrowBackIcon />} color="secondary" onClick={gotoPreviousStep}>
                Retour
              </MaterialButton>
            </Box>
          </Grid>
          {!shouldHideNext && (
            <ContinueButton
              state={state}
              isMobile={isMobile}
              shouldDisableContinueButton={shouldDisableContinueButton}
              gotoNextStep={gotoNextStep}
            />
          )}
        </>
      )}
    </StaticFooter>
  );
};
